import { temporarilyNotSupport } from '../../utils'

// 文件
export const saveFileToDisk = /* @__PURE__ */ temporarilyNotSupport('saveFileToDisk')
export const saveFile = /* @__PURE__ */ temporarilyNotSupport('saveFile')
export const removeSavedFile = /* @__PURE__ */ temporarilyNotSupport('removeSavedFile')
export const openDocument = /* @__PURE__ */ temporarilyNotSupport('openDocument')
export const getSavedFileList = /* @__PURE__ */ temporarilyNotSupport('getSavedFileList')
export const getSavedFileInfo = /* @__PURE__ */ temporarilyNotSupport('getSavedFileInfo')
export const getFileSystemManager = /* @__PURE__ */ temporarilyNotSupport('getFileSystemManager')
export const getFileInfo = /* @__PURE__ */ temporarilyNotSupport('getFileInfo')
